import { HTTPError, TimeoutError } from 'ky'

export class ApiClientError extends Error {
  public readonly status: number
  public readonly statusText: string
  public readonly url: string
  public readonly data?: unknown
  public readonly params?: Record<string, unknown>
  public readonly originalError: HTTPError

  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error.message)
    this.name = this.constructor.name
    this.status = error.response.status
    this.statusText = error.response.statusText
    this.url = error.request.url
    this.originalError = error
    this.data = data
    this.params = params
  }
}

export class BadRequestError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Bad Request: ${error.message}`
  }
}

export class UnauthorizedError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Unauthorized: ${error.message}`
  }
}

export class ForbiddenError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Forbidden: ${error.message}`
  }
}

export class NotFoundError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Not Found: ${error.message}`
  }
}

export class MethodNotAllowedError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Method Not Allowed: ${error.message}`
  }
}

export class ConflictError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Conflict: ${error.message}`
  }
}

export class UnprocessableEntityError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Unprocessable Entity: ${error.message}`
  }
}

export class TooManyRequestsError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Too Many Requests: ${error.message}`
  }
}

export class InternalServerError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Internal Server Error: ${error.message}`
  }
}

export class BadGatewayError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Bad Gateway: ${error.message}`
  }
}

export class ServiceUnavailableError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Service Unavailable: ${error.message}`
  }
}

export class GatewayTimeoutError extends ApiClientError {
  constructor(error: HTTPError, data?: unknown, params?: Record<string, unknown>) {
    super(error, data, params)
    this.message = `Gateway Timeout: ${error.message}`
  }
}

export class ApiTimeoutError extends Error {
  constructor(error: TimeoutError) {
    super(`Client Timeout: ${error.message}`)
    this.name = this.constructor.name
  }
}

export class ClientDisconnectedError extends Error {
  constructor(error: unknown) {
    super(`Client Disconnected: ${error}`)
    this.name = this.constructor.name
  }
}

export class EmptyResponseError extends Error {
  public readonly url: string
  public readonly status: number

  constructor(url: string, status: number) {
    super(`Empty or invalid response data received from ${url}`)
    this.name = this.constructor.name
    this.url = url
    this.status = status
  }
}
